import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { fadeUp, slideIn } from "@/lib/animations";
import { Section, Overline, H2 } from "./JobPrimitives";
import { requirements, differentials } from "./jobData";

export const JobRequirements = () => (
  <Section
    id="requisitos"
    className="py-16 md:py-24 bg-[#F6F8FB]"
    testid="section-requisitos"
  >
    <div className="grid lg:grid-cols-2 gap-10">
      <motion.div {...fadeUp}>
        <Overline>Requisitos</Overline>
        <H2 highlight="obrigatórios">Requisitos</H2>
        <ul className="mt-8 space-y-3">
          {requirements.map((r, idx) => (
            <motion.li
              key={r}
              {...slideIn(-20, idx * 0.05)}
              data-testid={`req-${idx}`}
              className="flex items-start gap-3 bg-white rounded-2xl border border-[#E5EAF2] p-4 hover:border-[#3787F5]/30 transition-colors"
            >
              <span className="shrink-0 w-8 h-8 rounded-lg bg-gradient-to-br from-[#3532B3] to-[#3787F5] text-white flex items-center justify-center text-xs font-bold shadow-[0_4px_10px_rgba(53,50,179,0.25)]">
                {idx + 1}
              </span>
              <p className="text-[15px] text-[#1F2937] pt-1 leading-relaxed">
                {r}
              </p>
            </motion.li>
          ))}
        </ul>
      </motion.div>

      <motion.div {...fadeUp}>
        <Overline>Diferenciais</Overline>
        <H2 highlight="um diferencial">Será considerado</H2>
        <ul className="mt-8 space-y-3">
          {differentials.map((d, idx) => (
            <motion.li
              key={d}
              {...slideIn(20, idx * 0.05)}
              data-testid={`diff-${idx}`}
              className="flex items-start gap-3 bg-white rounded-2xl border border-[#E5EAF2] p-4 hover:border-[#12DDB5]/50 transition-colors"
            >
              <span className="shrink-0 w-8 h-8 rounded-lg bg-gradient-to-br from-[#12DDB5] to-[#73F2B3] text-[#0b5a4a] flex items-center justify-center shadow-[0_4px_10px_rgba(18,221,181,0.3)]">
                <Sparkles size={14} strokeWidth={2.4} />
              </span>
              <p className="text-[15px] text-[#1F2937] pt-1 leading-relaxed">
                {d}
              </p>
            </motion.li>
          ))}
        </ul>
      </motion.div>
    </div>
  </Section>
);
